<template>
    <el-dialog :title="editMode ? 'Einheit bearbeiten' : 'Neue Einheit'" :visible.sync="$parent.showForm" width="400px">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-row>
                <el-col>
                    <el-form-item>
                        <el-select style="width: 100%" v-model="form.status" placeholder="Select Status" remote default-first-option>
                            <el-option
                                v-for="status in panelStatuses"
                                :key="status.id"
                                :label="status.value"
                                :value="status.id"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                    <el-form-item :class="[form.error ? 'is-error' : '' ]" label="Einheit Name" prop="panel_name">
                        <el-input
                                placeholder="Name"
                                v-model="form.panel_name"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--<el-row>-->
                <!--<el-col :span="24">-->
                    <!--<el-form-item :class="[form.error ? 'is-error' : '' ]" label="Cost" prop="panel_cost">-->
                        <!--<el-input-->
                                <!--placeholder="Cost"-->
                                <!--type="number"-->
                                <!--v-model="form.panel_cost"/>-->
                    <!--</el-form-item>-->
                <!--</el-col>-->
            <!--</el-row>-->
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm('form')">
                Bestätigen
                <i v-if="formSubmitted" class="el-icon-loading"></i>
            </el-button>
            <el-button @click="closeForm">Abbrechen</el-button>
        </span>
    </el-dialog>
</template>

<script>
    /* eslint-disable no-console */

    import { mapGetters } from 'vuex';
    import { ADD_PANEL, UPDATE_PANEL } from '../../../store/types';

    export default {
        name: 'PanelForm',
        computed: {
            ...mapGetters(['get_building', 'get_wording']),
            defaultPanelPrice () {
                const buildingId = this.$route.params.buildingId;
                return this.get_building(buildingId).default_panel_price;
            },
            defaultPanelName () {
                return `${this.get_wording('panel_name')}`;
            },
        },
        data () {
            const validatePanelCost = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('Field is empty!'));
                }

                const pattern = new RegExp(/^[+]?(?=.)(?:\d+,)*\d*(?:\.\d+)?$/);
                if (!pattern.test(value)) {
                    callback(new Error('Not a valid number!'));
                }

                callback();
            };
            return {
                formLabelWidth: '120px',
                dialogFormVisible: false,
                formSubmitted: false,
                editMode: false,
                form: {
                    status: 1,
                    panel_name: `${this.defaultPanelName} ${this.$parent.field.panels.length + 1}`,
                    panel_cost: 0.00,
                },
                rules: {
                    status: [
                        { required: true, message: 'Status required!', trigger: 'change' },
                    ],
                    panel_name: [
                        { required: true, message: 'Name required!', trigger: 'change' },
                    ],
                    panel_cost: [
                        { validator: validatePanelCost, trigger: 'change' },
                    ],
                },
            };
        },
        props: {
            formData: {},
            formVisible: {
                type: Boolean,
                required: true,
            },
            panelStatuses: {},
        },
        watch: {
            formData (newVal) {
                if (Object.prototype.hasOwnProperty.call(newVal, 'id')) {
                    this.form = newVal;
                    this.editMode = true;
                } else {
                    this.editMode = false;
                    this.form = {
                        status: 1,
                        panel_name: `${this.defaultPanelName} ${this.$parent.field.panels.length + 1}`,
                        panel_cost: this.defaultPanelPrice,
                    };
                }
            },
        },
        methods: {
            closeForm () {
                this.$parent.showForm = false;
            },
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        const fieldId = this.$parent.field.id;
                        const data = this.form;
                        this.formSubmitted = true;
                        if (this.editMode) {
                            this.$store.dispatch(UPDATE_PANEL, data).then((resp) => {
                                this.closeForm();
                                this.formSubmitted = false;
                                this.$message.success(resp.message);
                            });
                        } else {
                            this.$store.dispatch(ADD_PANEL, { fieldId, data }).then((resp) => {
                                this.closeForm();
                                this.formSubmitted = false;
                                this.$message.success(resp.message);
                            });
                        }
                    }
                });
            },
        },
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/fields/PanelForm.vue